// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2fim_","head":"Table_head__3OgrS","col":"Table_col__52-fF"};